export default __webpack_public_path__ + "assets/images/aa147936e53ade3f6a3ec19d3c4309a9.svg";